import { Spinner } from '@fluentui/react-components';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { getAuthFromQueryClient } from '../lib/auth/hooks';

const SettingsLayout = lazy(() =>
  import('../pages/settings/SettingsLayout').then((m) => ({
    default: m.SettingsLayout,
  })),
);

export const Route = createFileRoute('/settings')({
  beforeLoad: async ({ context }) => {
    const auth = await getAuthFromQueryClient(context.queryClient);

    // Not authenticated - redirect to login
    if (!auth?.user) {
      throw redirect({
        to: '/login',
        search: { redirectTo: '/settings' },
      });
    }

    // Check role
    const ALLOWED_ROLES = ['admin', 'user', 'org-admin'] as const;
    if (!ALLOWED_ROLES.includes(auth.user.role as (typeof ALLOWED_ROLES)[number])) {
      throw redirect({ to: '/unauthorized' });
    }
  },
  component: () => (
    <Suspense fallback={<Spinner style={{ position: 'absolute', top: '25%', left: '50%' }} />}>
      <SettingsLayout>
        <Outlet />
      </SettingsLayout>
    </Suspense>
  ),
});
